export default __webpack_public_path__ + "static/GT-America-Standard-Bold-ec2558e9ad3c869eb39b7f27aa26dedf.ttf";